/*
 * Copyright © 2022. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

export const serviceContractFormDefinitions = {};
